module.exports = __webpack_public_path__ + "img/ic_404.a57b6f31.png";